import {UserProfile} from './user-profile';

export class User {
  profile: UserProfile;

  constructor(technicalID: string) {
    this.profile = new UserProfile(technicalID);
  }

  public getProfile(): UserProfile {
    return this.profile;
  }
}
